/* ----------------------------------------------------------------------------
applies the saved theme and mode before first paint
loaded as a classic, render-blocking script in <head> so there's no flash of
the default theme; app.js is a module and runs too late for this
---------------------------------------------------------------------------- */
document.documentElement.classList.add('js');
try {
	const theme = localStorage.getItem('theme') || 'default';
	const mode = localStorage.getItem('mode') || 'system';
	if (theme !== 'default') document.documentElement.classList.add(theme);
	if (mode !== 'system') document.documentElement.classList.add(mode);
} catch {
	// storage can be blocked; fall back to the default theme and system mode
}
